// extracted by mini-css-extract-plugin
export default {"modalContainer":"vr","fadeRight":"wr","fadeUp":"xr","topShelf":"yr","newFlavorBadge":"zr","transparentText":"Ar","cancelButton":"Br","invisibleLink":"Cr","closeIcon":"Er","linkContainer":"Fr","hed":"Gr","image":"Hr"};
    if(module.hot) {
      // 1713361643379
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  